import type { PremiumProductProps } from 'bundles/browse/components/Domain/withPremiumProductCollections';
import {
  buildProgramAbsoluteUrl,
  filterNullOrUndefined,
} from 'bundles/browse/components/Domain/withPremiumProductCollections';
import type {
  GetStackableDegreesForBrowse_DegreeFragment as StackableDegree,
  GetStackableDegreesForBrowse_PartnerFragment as StackableDegreePartner,
} from 'bundles/browse/components/__generated__/getStackableDegrees';
import { PRODUCT_TYPE_NAMES } from 'bundles/browse/constants';
import type { Partner } from 'bundles/browse/types/degree-list';

const getDegreePartnerFromStackableDegreePartner = (partner: StackableDegreePartner): Partner => {
  return {
    __typename: 'Partner_Partner',
    id: partner?.id,
    name: partner?.name,
    squareLogo: partner?.squareLogo,
  };
};

export const getDegreeProductFromStackableDegree = (degree: StackableDegree): PremiumProductProps => {
  return {
    ...degree,
    domainIds: [],
    marketingName: degree?.name,
    partner: degree?.partners?.[0] ? getDegreePartnerFromStackableDegreePartner(degree.partners[0]) : null,
    partners: degree?.partners
      ? {
          elements: degree.partners.filter(filterNullOrUndefined).map((partner) => {
            return getDegreePartnerFromStackableDegreePartner(partner);
          }),
        }
      : undefined,
    type: PRODUCT_TYPE_NAMES.DEGREE,
    link: buildProgramAbsoluteUrl(degree?.slug, PRODUCT_TYPE_NAMES.DEGREE),
    partnerIds: [],
  };
};
